/**
 * 判断当前环境是否为同花顺PC远航版客户端
 * 
 * 通过检测 window.HevoCef.IsHevoCef 方法来判断是否为同花顺PC远航版客户端
 * 注意：此环境在期货通环境中也可能存在，因此需要排除期货通PC客户端
 * 
 * @returns {boolean} 如果是同花顺PC远航版客户端返回 true，否则返回 false
 * 
 * @example
 * ```ts
 * import { isThsPcYhClient } from '@fu/matrix';
 * 
 * if (isThsPcYhClient()) {
 *   // 在同花顺PC远航版客户端中的处理逻辑
 *   console.log('当前在同花顺PC远航版客户端中');
 * }
 * ```
 * 
 * @since 1.0.0
 */
export function isThsPcYhClient(): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }
    
    // 检测 HevoCef 对象及其 IsHevoCef 方法
    const hasHevoCef = Boolean(
      window.HevoCef && 
      'IsHevoCef' in window.HevoCef
    );
    
    if (!hasHevoCef) {
      return false;
    }
    
    // 排除期货通PC客户端
    const isFuturesPc = Boolean(
      window.external && 
      'IsQhtWin' in window.external
    );
    
    return !isFuturesPc;
  } catch (error) {
    console.warn('检测同花顺PC远航版客户端失败:', error);
    return false;
  }
}
